import { List, Modal, Skeleton } from "antd";
import { useState } from "react";

interface AddEditVersion {
  taskDetails: any;
  onClosePopup: () => void;
}


    const TaskDetails: React.FC<AddEditVersion> = ({taskDetails ,onClosePopup}) => {
        console.log(taskDetails)
        const [isOpen,setIsOpen] = useState<boolean>(true)
        const closeDetails = () => {
            setIsOpen(false)
            onClosePopup()
        }
        const formatDate = (dateTimeString:any) => {
          if (!dateTimeString) {
            return 'Invalid Date';
          }
        
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          };
        
          const date = new Date(dateTimeString);
        
          if (isNaN(date.getTime())) {
            return 'Invalid Date';
          }
        return date.toLocaleString()
        };
    return <>
    <Modal open={isOpen} onCancel={closeDetails}  maskClosable={false}
 title="Task Details" footer={false}
>
    <List
                        size="small"
                        className="demo-loadmore-list"
                        itemLayout="horizontal"
                        dataSource={taskDetails.taskDetails}
                        renderItem={(item: any, index) => (
                          <List.Item
                          style={{float:'left'}}
                          >
                            <Skeleton
                              avatar
                              title={false}
                              loading={item.loading}
                              active
                            >
  
                              <List.Item.Meta /> 
                              {item.description}- {item.date}
                                             
                            </Skeleton>
                          </List.Item>
                        )}
                      />
    </Modal>
  </>
}
export default TaskDetails;